
import VideoPlayer from '@/components/VideoPlayer'
export default {
  components: {
    VideoPlayer,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
}
